import React, { Component } from 'react';
import FormSelectMarkup from './FormSelectLanguage';

class FormSelectLanguageComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectData: [{
				value: 'en',
				name: 'English'
			}, {
				value: 'es',
				name: 'Español'
			}]
        };

    }
    componentWillMount() {
        this.setState({ selectedValue: this.props.language });
    }
    handleSelectchange = (e) => {
		const languageCode = e.target.value;
		this.setState({ selectedValue: languageCode }, () => {
			this.props.currentLanguage(languageCode);
		});
    }
    render() {
        return (
            <FormSelectMarkup
                onChange={this.handleSelectchange.bind(this)}
                data={this.state.selectData}
                selectedValue={this.state.selectedValue}
                classType="navigation__language"
            />
        )
    }
}

export default FormSelectLanguageComponent;


// WEBPACK FOOTER //
// ./src/redux/components/atoms/FormSelectLanguage/Component.js